import React, { SFC } from 'react';

import { Card, Collapse, Icon } from 'antd';
import { CollapsePanelProps } from 'antd/lib/collapse';
import styled from 'styled-components';
import { SubformPanelHeader } from './SubformPanelHeader';

type SubformPanelProps = Pick<CollapsePanelProps, Exclude<keyof CollapsePanelProps, 'header'>> & {
    title: string;
    showCheckMark: boolean;
};

const SubformPanelWrapper = styled(Card)`
    margin-bottom: 24px !important;
    .ant-card-body {
        padding: 0 !important;
    }
    .ant-collapse-header {
        padding: 20px 40px !important;
    }
`;

const Panel = styled(Collapse.Panel)`
    border: 0 !important;
    .ant-collapse-content-box {
        padding: 0 !important;
    }
`;

const PanelContentWrapper = styled.div`
    padding: 16px 40px 24px;
`;

const Seperator = styled.div`
    border-bottom: 1px solid #e8e8e8;
`;

const expandedIcon: SFC<{ isActive: boolean }> = ({ isActive }) => (
    <Icon type="caret-right" rotate={isActive ? 90 : 0} />
);

export const SubformPanel: SFC<SubformPanelProps> = ({ title, showCheckMark, children }) => (
    <SubformPanelWrapper bordered={false}>
        <Collapse bordered={false} expandIcon={expandedIcon}>
            <Panel
                key="1"
                header={<SubformPanelHeader text={title} showCheckMark={showCheckMark} />}
            >
                <Seperator />
                <PanelContentWrapper>{children}</PanelContentWrapper>
            </Panel>
        </Collapse>
    </SubformPanelWrapper>
);
